import { Button, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import type { DwhSyncLogs } from "../../../../api/types/integrationsTypes";
import LogDetailsDialog from "../../../common/syncLogs/LogDetailsDialog";
import LogStatusIcon from "../../../common/syncLogs/LogStatusIcon";
import LogsTableWrapper from "../../../common/syncLogs/LogsTableWrapper";
import type { LogsTableRowData } from "./logsTableDataProvider";
import { getRows } from "./logsTableDataProvider";

interface Props {
  logItems: DwhSyncLogs[];
}

interface LogsTableRowProps extends LogsTableRowData {
  onView: (details: DwhSyncLogs) => void;
}

const LogsTableHeadRow = () => (
  <TableRow>
    <TableCell>Status</TableCell>
    <TableCell>Completed</TableCell>
    <TableCell>Event Type</TableCell>
    <TableCell align="right">Changes</TableCell>
    <TableCell>Actions</TableCell>
  </TableRow>
);

const LogsTableRow = ({ severity, completed, eventType, numberOfChanges, details, onView }: LogsTableRowProps) => {
  const handleViewClick = () => onView(details);

  return (
    <TableRow hover>
      <TableCell width="10%">
        <LogStatusIcon severity={severity} />
      </TableCell>
      <TableCell>{completed}</TableCell>
      <TableCell>{eventType}</TableCell>
      <TableCell align="right" width="15%">
        {numberOfChanges}
      </TableCell>
      <TableCell align="right" className="LogsTable-actions" width="15%" padding="checkbox">
        <Button variant="text" color="primary" onClick={handleViewClick}>
          View
        </Button>
      </TableCell>
    </TableRow>
  );
};

const LogsTable = ({ logItems }: Props) => {
  const [logDetails, setLogDetails] = useState<DwhSyncLogs>();
  const [showLogDetails, setShowLogDetails] = useState(false);

  const handleViewDetails = (logDetails: DwhSyncLogs) => {
    setLogDetails(logDetails);
    setShowLogDetails(true);
  };

  const handleLogDetailsClose = () => setShowLogDetails(false);

  const rows = getRows(logItems);

  return (
    <>
      <LogsTableWrapper maxHeight="calc(100vh - 530px)">
        <TableHead>
          <LogsTableHeadRow />
        </TableHead>
        <TableBody>
          {rows.map(({ key, ...row }) => (
            <LogsTableRow key={key} {...row} onView={handleViewDetails} />
          ))}
        </TableBody>
      </LogsTableWrapper>
      <LogDetailsDialog open={showLogDetails} onClose={handleLogDetailsClose} logDetails={logDetails} />
    </>
  );
};

export default LogsTable;
